module.exports = __webpack_public_path__ + "img/70m5.60569c01.jpg";